import Phonetics from "./Phonetics";
import "./Phonetics.scss";

export default Phonetics;
